import React, { useContext } from 'react';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import { SearchBarRetentionContainer } from '../SearchBarRetention/SearchBarRetention.style';
import { RetentionSearchContext } from './RetentionSearchContext';

const RetentionSearchBar = () => {
    const { query, error, loading, setQuery, submit } = useContext(RetentionSearchContext);

    const handleChange = (_: string, value: string) => {
        setQuery(value);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') submit();
    };

    return (
        <SearchBarRetentionContainer>
            <div className="container-search">
                <TextField
                    name="retention_search"
                    dataId="retention_search"
                    id="retention_search"
                    originType="pcom"
                    label="Buscar cliente por correo electrónico"
                    clearable
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    error={!!error}
                    value={query}
                    errorMessage={error}
                />
            </div>
            <Button
                type="submit"
                variant="primary"
                dataId="button-retention-search"
                originType="pcom"
                size="large"
                fluid
                onClick={submit}
                loading={loading}
            >
                Buscar
            </Button>
        </SearchBarRetentionContainer>
    );
};

export default RetentionSearchBar;
